import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityAmount from 'apps/auth/components/ga/activity/components/ActivityAmount';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { getGaActivityDate } from 'apps/auth/helpers/utils';

const ActivityDeliveryDetails = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const getStatusText = () => {
        let statusText;
        if (item.mobileInfo.stsId < STATUS_OK) {
            statusText = props.chequeStatusInProgress;
        } else if (item.mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = props.chequeStatusCanceled;
        } else if (item.mobileInfo.stsId > STATUS_OK) {
            statusText = props.chequeStatusError;
        }
        if (statusText) {
            return statusText;
        }
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent={mobileInfo.stsId !== STATUS_OK && !item.payComment ? 'adaptive-24-32' : null}>
                <ActivityAmount item={item} options={props.options} />
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus status={mobileInfo.stsId} comment={item.payComment} text={getStatusText()} />
            </Row>
            {mobileInfo.errorMessage && <div>{mobileInfo.errorMessage}</div>}

            <Separator marginTop="48px" marginBottom="48px" />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
                {mobileInfo.extraFields?.Delivery && (
                    <TableRow title={props.chequeDeliveryHeader} textColor={textColor} titleColor={titleColor}>
                        {mobileInfo.extraFields.Delivery}
                    </TableRow>
                )}
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    chequeDeliveryHeader: state.messages.pageMessages.chequeDeliveryHeader,
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeStatusCanceled: state.messages.pageMessages.chequeStatusCanceled,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeDate: state.messages.pageMessages.chequeDate,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(ActivityDeliveryDetails);
